<template>
  <vue-base-dialog ref="VueBaseDialog" :dialogConfig="dialogConfig" @close="closeBox">
    <div class="dialog-content">
      <video id="player-container-id" playsinline webkit-playsinline>
      </video>
    </div>
  </vue-base-dialog>
</template>
<script>
import VueBaseDialog from './VueBaseDialog'
export default {
  name: 'PlayBox',
  components: {
    VueBaseDialog
  },
  props: {
    dialogConfig: {
      type: Object,
      default: () => {
        return {
          type: "",
          name: "",
          fileId: "",
          path: "",
          title: "",
        }
      }
    },
    addPlayLogMethod: { // 添加播放记录
      type: Function,
      default: null
    },
  },
  data () {
    return {
      player: null,
      currentTime: 0,
    }
  },

  mounted () {
    let arr1 = document.querySelector(`[src='${window.location.origin + "/vod/hls.min.0.13.2m.js"}']`);
    let arr2 = document.querySelector(`[src='${window.location.origin + "/vod/tcplayer.min.js"}']`);
    if (arr1 && arr2) {
      this.initPlayer();
    } else {
      this.loadScript(window.location.origin + "/vod/hls.min.0.13.2m.js", () => {
        this.loadScript(window.location.origin + "/vod/tcplayer.min.js", () => {
          this.initPlayer();
        })
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.inter)
    this.inter = null
    this.player.dispose();
    this.player = null;
  },
  methods: {
    initPlayer () {
      this.player = window.TCPlayer('player-container-id', {
        width: 1000,
        height: 562.5,
        fileID: this.dialogConfig.fileId,
        appID: '1500004122',
        posterImage: true,
        bigPlayButton: true,
        autoplay: false,
        controlBar: {
          playbackRateMenuButton: false,
          QualitySwitcherMenuButton: false,
        }
      });
    },
    loadScript (url, callback) {
      if (typeof document !== "undefined") {
        var script = document.createElement("script");
      }
      script.type = "text/javascript";
      if (typeof callback !== "undefined") {
        if (script.readyState) {
          script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              callback();
            }
          };
        } else {
          script.onload = function () {
            callback();
          };
        }
      }
      script.src = url;
      if (typeof document !== "undefined") {
        document.head.appendChild(script);
      }
    },
    closeBox(){
      this.$emit('closeBox', this.player.currentTime())
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-content {
    text-align: left;
}
.public-dialog-btn-box {
    margin-top: 10px;
}
#player-container-id /deep/ .tcp-skin .vjs-progress-control {
    top: 0;
}
::v-deep .video-js {
    width: 67.5vw !important;
    // aspect-ratio: 16 / 9 !important;
    // height: auto !important;
    // padding-top: 56.3% !important;
}

// 适配h5
@media screen and (max-width: 700px) {  
  ::v-deep .video-js {
    width: 80vw !important; 
    height: 350px !important;
  }
}
</style>